'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class;

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _reduxUi = require('redux-ui');

var _reduxUi2 = _interopRequireDefault(_reduxUi);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _clipboard = require('clipboard');

var _clipboard2 = _interopRequireDefault(_clipboard);

var _pacomo = require('utils/pacomo');

var _forms = require('utils/forms');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    ReminderModal: {
        displayName: 'ReminderModal'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/PassengerList/ReminderModal.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var syncValidation = (0, _forms.formSyncValidation)({
    requiredValues: ['recipientEmail'],
    emailValues: ['recipientEmail']
});

var ReminderModal = _wrapComponent('ReminderModal')((_dec = (0, _reduxUi2.default)(), _dec2 = (0, _reduxForm.reduxForm)({
    form: 'reminderModal',
    enableReinitialize: true,
    validate: syncValidation
}), _dec(_class = _dec2(_class = (0, _pacomo.pacomoDecorator)(_class = function (_Component) {
    (0, _inherits3.default)(ReminderModal, _Component);

    function ReminderModal(props) {
        (0, _classCallCheck3.default)(this, ReminderModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ReminderModal.__proto__ || (0, _getPrototypeOf2.default)(ReminderModal)).call(this, props));

        _this.state = {
            isRecentlyCopied: false,
            isRecentlySubmitted: false
        };
        return _this;
    }

    (0, _createClass3.default)(ReminderModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.clipboard = new _clipboard2.default('#copyUrlTrigger');

            this.clipboard.on('success', function (e) {
                _this2.triggerCopiedTimeout();
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // if finished submitting and succeeded
            if (this.props.submitting && !nextProps.submitting && nextProps.submitSucceeded) {
                this.triggerSubmittedTimeout();
            }
        }
    }, {
        key: 'triggerCopiedTimeout',
        value: function triggerCopiedTimeout() {
            var _this3 = this;

            // overwrite last timer if not yet finished
            clearTimeout(this.copiedTimeoutId);

            this.setState({ isRecentlyCopied: true });

            this.copiedTimeoutId = setTimeout(function () {
                _this3.setState({ isRecentlyCopied: false });
            }, 3000);
        }
    }, {
        key: 'triggerSubmittedTimeout',
        value: function triggerSubmittedTimeout() {
            var _this4 = this;

            // overwrite last timer if not yet finished
            clearTimeout(this.submittedTimeoutId);

            this.setState({ isRecentlySubmitted: true });

            this.submittedTimeoutId = setTimeout(function () {
                _this4.setState({ isRecentlySubmitted: false });
            }, 3000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            // remove timers if not yet finished
            clearTimeout(this.copiedTimeoutId);
            clearTimeout(this.submittedTimeoutId);

            // destroy clipboard
            this.clipboard.destroy();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                ui = _props.ui,
                updateUI = _props.updateUI,
                sendReminder = _props.sendReminder,
                initialValues = _props.initialValues,
                handleSubmit = _props.handleSubmit,
                error = _props.error,
                invalid = _props.invalid,
                pristine = _props.pristine,
                submitting = _props.submitting,
                submitSucceeded = _props.submitSucceeded;

            var isInvalid = invalid;
            if (!initialValues.recipientEmail && pristine && !invalid) {
                // weird bug
                isInvalid = true;
            }
            return _react3.default.createElement(
                'div',
                {
                    className: 'reminder-modal ' + (ui.reminderModalIsVisible ? 'is-visible' : 'is-hidden'),
                    tabIndex: '-1',
                    role: 'dialog' },
                _react3.default.createElement('div', { className: 'overlay' }),
                _react3.default.createElement(
                    'form',
                    null,
                    _react3.default.createElement(
                        'div',
                        { className: 'modal-dialog', role: 'document' },
                        _react3.default.createElement(
                            'div',
                            { className: 'modal-content' },
                            _react3.default.createElement(
                                'div',
                                { className: 'modal-header' },
                                _react3.default.createElement(
                                    'button',
                                    {
                                        className: 'close',
                                        type: 'button',
                                        onClick: function onClick() {
                                            updateUI("reminderModalIsVisible", !ui.reminderModalIsVisible);
                                        } },
                                    _react3.default.createElement(
                                        'span',
                                        { 'aria-hidden': 'false' },
                                        '\xD7'
                                    )
                                ),
                                _react3.default.createElement(
                                    'h4',
                                    { className: 'modal-title' },
                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'reminderModal.title',
                                        defaultMessage: 'Good to Go Reminder' })
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'modal-body' },
                                _react3.default.createElement(_components2.FormErrorMessage, { errorCode: error, submitting: submitting }),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'form-group' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'row' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'col-3' },
                                            _react3.default.createElement(
                                                'label',
                                                { htmlFor: 'recipientEmail', className: 'form-control-label' },
                                                _react3.default.createElement(_reactIntl.FormattedMessage, {
                                                    id: 'reminderModal.recipient',
                                                    defaultMessage: 'Reminder' })
                                            )
                                        ),
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'col-9' },
                                            _react3.default.createElement(_reduxForm.Field, {
                                                id: 'recipientEmail',
                                                name: 'recipientEmail',
                                                component: _components2.Input,
                                                type: 'email' }),
                                            _react3.default.createElement(
                                                'div',
                                                { className: 'form-group reminder-text' },
                                                _react3.default.createElement(
                                                    'p',
                                                    null,
                                                    _react3.default.createElement(_reactIntl.FormattedMessage, {
                                                        id: 'reminderModal.privacyNotice',
                                                        defaultMessage: 'This email will be used for the purpose of sending this reminder.' })
                                                )
                                            )
                                        )
                                    )
                                )
                            ),
                            _react3.default.createElement(
                                'div',
                                { className: 'modal-footer' },
                                _react3.default.createElement(
                                    'button',
                                    {
                                        type: 'submit',
                                        className: (0, _classnames2.default)('button', {
                                            'submitting': submitting || this.state.isRecentlySubmitted
                                        }),
                                        disabled: submitting || isInvalid || this.state.isRecentlySubmitted,
                                        onClick: handleSubmit },
                                    !submitting && (!this.state.isRecentlySubmitted && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'reminderModal.sendButton',
                                        defaultMessage: 'Send Reminder' }) || this.state.isRecentlySubmitted && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'reminderModal.sent',
                                        defaultMessage: 'Sent!' })),
                                    submitting && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'reminderModal.sending',
                                        defaultMessage: 'Sending...' })
                                ),
                                _react3.default.createElement(
                                    'div',
                                    { className: 'clipboard' },
                                    _react3.default.createElement(_reduxForm.Field, {
                                        id: 'checkinUrl',
                                        name: 'checkinUrl',
                                        component: 'input',
                                        type: 'text',
                                        readOnly: true }),
                                    _react3.default.createElement(
                                        'button',
                                        {
                                            id: 'copyUrlTrigger',
                                            type: 'button',
                                            className: 'btn btn-secondary',
                                            'data-clipboard-target': '#checkinUrl' },
                                        !this.state.isRecentlyCopied && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'reminderModal.copyUrl',
                                            defaultMessage: 'Copy Url' }),
                                        this.state.isRecentlyCopied && _react3.default.createElement(_reactIntl.FormattedMessage, {
                                            id: 'reminderModal.copiedUrl',
                                            defaultMessage: 'Copied!' })
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return ReminderModal;
}(_react2.Component)) || _class) || _class) || _class));

exports.default = ReminderModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/PassengerList/ReminderModal.js
// module id = 1309
// module chunks = 0